import { Permission } from '@today/types'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'
import { OfferDetailPage } from './OfferDetailPage'
import { OfferMessagePage } from './OfferMessagePage'
import { OfferNewPage } from './OfferNewPage'
import { OfferProductSelectionPage } from './OfferProductSelectionPage'
import { OfferSendPage } from './OfferSendPage'
import { OffersListPage } from './OffersListPage'

/**
 * Offer routes — permission-gated; without the permission the Forbidden page
 * renders before any request. List, wizard shell and detail (TO-466
 * offer-generation-status REQ-005); Step 2 (TO-123) needs both `offer.write` (it
 * changes the draft) and `product.read` (it lists the catalogue); Step 3 (TO-124,
 * `offers/:offerId/message`) needs `offer.write` (it autosaves the draft and renders
 * its preview); Step 4 (TO-125, `offers/:offerId/send`) needs `offer.write`. Static segments
 * (`offers/new`) outrank `offers/:offerId` in react-router regardless of order.
 * Children of the app's `/` layout route.
 */
export const offerPageRoutes: RouteObject[] = [
	{
		path: 'offers',
		element: (
			<RequirePermission permission={Permission.OFFER_READ}>
				<OffersListPage />
			</RequirePermission>
		),
	},
	{
		path: 'offers/new',
		element: (
			<RequirePermission permission={Permission.OFFER_WRITE}>
				<OfferNewPage />
			</RequirePermission>
		),
	},
	{
		path: 'offers/:offerId',
		element: (
			<RequirePermission permission={Permission.OFFER_READ}>
				<OfferDetailPage />
			</RequirePermission>
		),
	},
	{
		path: 'offers/:offerId/products',
		element: (
			<RequirePermission permission={Permission.OFFER_WRITE}>
				<RequirePermission permission={Permission.PRODUCT_READ}>
					<OfferProductSelectionPage />
				</RequirePermission>
			</RequirePermission>
		),
	},
	{
		path: 'offers/:offerId/message',
		element: (
			<RequirePermission permission={Permission.OFFER_WRITE}>
				<OfferMessagePage />
			</RequirePermission>
		),
	},
	{
		path: 'offers/:offerId/send',
		element: (
			<RequirePermission permission={Permission.OFFER_WRITE}>
				<OfferSendPage />
			</RequirePermission>
		),
	},
]
